import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticVehiclesInput,
    LogisticVehicles
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticVehiclesService {
    private amplifyClient = generateClient();
    constructor() {}

    async listLogisticVehicles(): Promise<LogisticVehicles[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticVehicles
                })
            ).data.listLogisticVehicles.items;
            if (data) return data as LogisticVehicles[];
        } catch (error) {
            console.error('Error finding LogisticVehicles:', error);
            return null;
        }
    }

    async listAllLogisticVehicles(
        pageLimit: number = 100
    ): Promise<LogisticVehicles[]> {
        const vehicles: LogisticVehicles[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticVehicles,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticVehicles;
                vehicles.push(
                    ...((response?.items ?? []) as LogisticVehicles[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return vehicles;
        } catch (error) {
            console.error('Error finding LogisticVehicles:', error);
            return [];
        }
    }

    async createLogisticVehicles(
        input: CreateLogisticVehiclesInput
    ): Promise<LogisticVehicles> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticVehicles,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticVehicles;
            if (date) return date as LogisticVehicles;
        } catch (error) {
            console.error('Error creating LogisticZone:', error);
            return null;
        }
    }
}
